import React from 'react';
import DarkMarketingPage from '../Shared/DarkMarketingPage';
import Traffic from '../../../images/marketing/marketing/traffic.png';
import MarketingImgFirst from '../../../images/marketing/marketing/marketing-img-first.jpg';
import MarketingImgSecond from '../../../images/marketing/marketing/marketing-img-second.jpg';
import Language from '../../../images/marketing/marketing/language.png';

const sections = [
  {
    label: 'BOOST TRAFFIC FEATURE',
    icon: Traffic,
    title: 'Boost Traffic',
    description:
      'We make it easy for people to see who you are on the web. EditPage boost traffic feature is simple to use and easy to understand. Grow your business fast.',
    link: '/marketing',
    image: MarketingImgFirst,
  },
  {
    label: 'SOCIAL MEDIA',
    icon: Language,
    title: 'Social Media',
    description:
      'Connecting with the right audience at the right time can really help sales grow. Making sure you run the best social media campaigns.',
    link: '/marketing',
    image: MarketingImgSecond,
    reverse: true,
  },
];

const quickTags = [
  'Traffic Boosting',
  'Social Campaigns',
  'Audience Growth',
  'Campaign Insights',
  'Simple Setup',
  'Faster Reach',
];

const MarketingContent = ({ history }) => (
  <DarkMarketingPage
    history={history}
    title="EditPage Marketing"
    subtitle="EditPage will help you market your website to the world."
    sections={sections}
    quickTags={quickTags}
  />
);

export default MarketingContent;
